import { render, staticRenderFns } from "./MemberArea.vue?vue&type=template&id=60d7f34c&scoped=true&"
import script from "./MemberArea.vue?vue&type=script&lang=js&"
export * from "./MemberArea.vue?vue&type=script&lang=js&"
import style0 from "./MemberArea.vue?vue&type=style&index=0&id=60d7f34c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d7f34c",
  null
  
)

export default component.exports